/* angular */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipModule,  SolModalModule } from '@solar/components';
import { NgbDropdownModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';

import { DownloadMobileAppComponent } from './download-mobile-app.component';

import { ExperienceService } from '../../services/experience.service';

// Translate
import { TranslateModule } from '@ngx-translate/core';

// Generate QR code
import { QRCodeModule } from 'angularx-qrcode';

@NgModule({
	imports: [
		ChipModule,
		CommonModule,
		RouterModule,
		FormsModule,
		ReactiveFormsModule,
		NgbDropdownModule,
		SolModalModule,
		NgbModalModule,
		TranslateModule.forChild({}),
		QRCodeModule
	],
	exports: [
		DownloadMobileAppComponent,
	],
	providers: [
		ExperienceService	
	],
	declarations: [
		DownloadMobileAppComponent,
	]
})

export class DownloadMobileAppModule { }


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/components/mobile/download-mobile-app.module.ts